import { SET_OPEN_STATE } from '../actions/types';
import {Map, fromJS} from 'immutable';
function openState(state = Map({isOpen : ''}), action) {
    switch (action.type) {
        case SET_OPEN_STATE:
            return fromJS(action.payload)
        default:
            return state;
    }
}

export default openState;



// WEBPACK FOOTER //
// ./redux/reducers/openState.js